import * as React from "react";
import { SVGProps } from "react";

const BCISimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={52}
    height={24}
    viewBox="0 0 52 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(-26, -22)" fill="currentColor">
      <path opacity={0.7} d="M72.46,25.8c0-.87.69-1.59,1.51-1.59s1.52.71,1.51,1.59c0,.87-.69,1.59-1.51,1.59s-1.51-.72-1.51-1.59Z"/>
      <g>
        <path opacity={0.7} d="M69.39,32.76c-.79-.84-1.55-1.21-2.47-1.21-1.76,0-3.15,1.54-3.14,3.5v.03c0,1.95,1.43,3.54,3.18,3.54.83,0,1.55-.32,2.26-1.02l1.96,1.99c-1.21,1.26-2.6,1.88-4.25,1.88-3.26,0-5.92-2.86-5.92-6.35v-.03c0-3.51,2.65-6.35,5.93-6.35,2.09,0,3.41.98,4.33,1.94l-1.89,2.09Z"/>
        <path opacity={0.7} fillRule="evenodd" d="M59.56,29.66c0,1.08-.36,2.18-1.15,3.01,1.13.82,1.63,2.23,1.62,3.66,0,2.72-1.39,4.88-5.43,4.88h-5.45v-16.16h5.36c3.78,0,5.05,2.08,5.05,4.61ZM54.57,27.92h-2.66v3.52h2.83c1.49,0,1.84-.92,1.84-1.77s-.29-1.74-2.01-1.74ZM51.91,38.35h2.78c1.97,0,2.37-1,2.39-2.01,0-1.39-.64-2.04-2.34-2.04h-2.83v4.05Z"/>
        <path opacity={0.7} d="M72.61,28.71h2.75v12.51h-2.75v-12.51Z"/>
        <path opacity={0.7} d="M28.53,40.65c.03,1.07.8,1.99,1.81,2.16.14.02.28.04.42.02.58-.02,1.11-.28,1.49-.72.39-.44.59-1.02.57-1.62,0-1.63.89-2.74,2.1-4,1.27-.99,3.08-2.19,5.63-3.69,3.17-1.78,5.24-3.89,5.69-5.61v-.05c.07-.22.09-.44.08-.66-.03-1.07-.8-1.99-1.81-2.16-.14-.02-.28-.04-.42-.02-.58.02-1.11.28-1.49.72-.39.44-.59,1.02-.57,1.62,0,1.72-.98,2.87-2.31,4.19-2.83,2.33-5.44,3.5-5.44,3.5-3.17,1.78-5.24,3.89-5.69,5.61v.05c-.06.23-.08.45-.07.66Z"/>
        <path opacity={0.3} d="M41.32,33.77s2.31.65,1.58,4.07c-.03.18-.06.37-.03.56.08,1.01.92,1.76,1.88,1.67.96-.09,1.66-.98,1.58-1.99-.16-2.38-4.41-5.29-4.99-5.22,0,0-.33.01-.33.46,0,.37.31.44.31.44Z"/>
        <path opacity={0.5} d="M40.93,34.74s1.51.43,1.04,2.66c0,0-.5,2.11-3.69,2.66-3.61.63-3.56-.77-3.56-.77-.03-.69-.28-1.54,3.31-3.83,0,0,1.81-1.17,2.9-.72Z"/>
        <path opacity={0.7} d="M31.89,24.53c.21,3.05,4.34,6.69,6.81,8.11.67.39,1.5.3,1.74.21,1.13-.55-.08-1.01-.08-1.01,0,0-3.89-1.1-2.68-6.88.07-.3.09-.62.07-.95-.14-1.71-1.56-2.97-3.17-2.83-1.63.15-2.83,1.65-2.69,3.35Z"/>
      </g>
    </g>
  </svg>
);

export default BCISimple;
